import { ListStatusCount } from './../../model/list-status-count.model';
import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { AccessRoleHelper } from '../../model/helpers/access-role.helper';
import { PortalHelpersService } from 'src/app/services/portal-helpers/portal-helpers.service';
import { ApplicationRoles, PortalSettings, SessionService, User } from '@edl-development/edl-common';

@Component({
    selector: 'edl-authenticated-navigation',
    templateUrl: './edl-authenticated-navigation.component.html',
    styleUrls: ['./edl-authenticated-navigation.component.scss']
})

export class EdlAuthenticatedNavigationComponent implements OnInit{
    ApplicationRoles = ApplicationRoles;
    AccessRoleHelper = AccessRoleHelper;

    user: User;

    supervisorManagementCollapsed: boolean = true;
    myComplianceItemsCollapsed: boolean = true;
    groupsCollapsed: boolean = true;
    questionnairesCollapsed: boolean = true;
    userManagementCollapsed: boolean = true;
    portalManagementCollapsed: Boolean = true;
    qfmCollapsed: boolean = true;
    groupManagementCollapsed: boolean = true;
    requestManagementCollapsed: boolean = true;
    listStatusCount: ListStatusCount;
    portalSettings:PortalSettings;


    constructor(
        public stateService: StateService,
        public sessionService: SessionService,
        public portalHelpersService: PortalHelpersService
    ) { 
        this.listStatusCount = new ListStatusCount() ;
    }

    ngOnInit() {
        this.portalSettings = this.sessionService.PortalSettings;
        this.user = this.sessionService.user;

        this.supervisorManagementCollapsed = !this.stateService.includes('authenticated.supervision-management');
        this.myComplianceItemsCollapsed = !this.stateService.includes('authenticated.my-compliance-items');
        this.userManagementCollapsed = !this.stateService.includes('authenticated.users');
        this.qfmCollapsed = !this.stateService.includes('authenticated.questionnaires.view');
        this.portalManagementCollapsed = !this.stateService.includes('authenticated.portal');
        this.groupManagementCollapsed = !this.stateService.includes('authenticated.groups');
        this.requestManagementCollapsed = !this.stateService.includes('authenticated.requests');

    }

    isInActiveState(loc:string){
        return this.stateService.includes(loc);
    }

    toggleMenu() {
        this.sessionService.toggleMenu();
    }
}